export default __webpack_public_path__ + "static/media/support1.06626324.svg";